module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar image = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};\n%>\n<div>\n<img alt=\"<%- image.alt %>\" titel=\"<%- image.title %>\" src=\"<%- image.url %>\">\n<p class=\"name\"><%= model.name %></p>\n<p class=\"phone\">T: <%- model.phone %></p>\n<p class=\"fax\">F: <%- model.fax %></p>\n<p class=\"contact\"><a href=\"mailto:<%- model.mail %>\"><%= model.mail %></a></p>\n</div>"
  , __filename = "components/templates/team/member.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var image = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};

    ; __line = 3
    ; __append("\n<div>\n<img alt=\"")
    ; __line = 5
    ; __append( image.alt )
    ; __append("\" titel=\"")
    ; __append( image.title )
    ; __append("\" src=\"")
    ; __append( image.url )
    ; __append("\">\n<p class=\"name\">")
    ; __line = 6
    ; __append(escapeFn( model.name ))
    ; __append("</p>\n<p class=\"phone\">T: ")
    ; __line = 7
    ; __append( model.phone )
    ; __append("</p>\n<p class=\"fax\">F: ")
    ; __line = 8
    ; __append( model.fax )
    ; __append("</p>\n<p class=\"contact\"><a href=\"mailto:")
    ; __line = 9
    ; __append( model.mail )
    ; __append("\">")
    ; __append(escapeFn( model.mail ))
    ; __append("</a></p>\n</div>")
    ; __line = 10
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/team/member.ejs

}